import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import {formValueSelector, reduxForm} from 'redux-form';
import {connect} from 'react-redux';

import {getValueFromLocalStorage} from '../../helpers/localStorage.helper';
import {checkOpeningTime, isDayBlocked} from '../../helpers/date.helper';
import {
  checkMessgeContainsError,
  getPlaceOrderButtonText,
  getServiceTypeInitialValue
} from '../../helpers/checkoutPage.helper';
import DeliveryAddress from './DeliveryAddress';
import ServiceType from './ServiceType';
import ConsumerData from './ConsumerData';
import FutureOrder from './FutureOrder';
import Comments from './Comments';
import Subscribe from './Subscribe';
import Payments from './Payments';
import ExtraInformation from './ExtraInformation';
import Form from './Form';
import {DINE_COMMENT, FOODIT_LOCALSTORAGE, PAYMENT_TYPES, SERVICE_TYPE} from '../../constants/constant';
import CheckoutErrorModal from '../../components/CheckoutErrorModal/CheckoutErrorModal';
import {NotDineIn, NotDineInLink} from './CheckoutPage.style';

class CheckoutForm extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      isFilledDataValidated: false,
      invalidForm: false,
      invalidFormClick: 0
    };

    this.handleFormErrors = this.handleFormErrors.bind(this);
    this.closeErrorModal = this.closeErrorModal.bind(this);
    this.isDatepickerDayBlocked = this.isDatepickerDayBlocked.bind(this);
  }

  componentWillReceiveProps() {
    if (!this.state.isFilledDataValidated) {
      this.setState({isFilledDataValidated: true});

      this.props.setServiceType(true);
    }
  }

  isDatepickerDayBlocked(day) {
    const openingTimes = this.props.restaurant.openingTimes[this.props.serviceTypeValue];
    return isDayBlocked(day, openingTimes);
  }

  handleFormErrors() {
    const {invalid, basket, checkoutForm} = this.props;
    if (invalid || (basket.messages && basket.messages.length > 0)) {
      this.setState({invalidForm: true, invalidFormClick: this.state.invalidFormClick + 1});
      const consumerName = document.getElementById('consumerName');
      const deliveryAddress = document.getElementById('deliveryAddress');
      if (checkoutForm && checkoutForm.syncErrors) {
        const errors = checkoutForm.syncErrors;
        if ((errors['addressLine1'] || errors['city'] || errors['postcode']) && (basket.fulfillment && basket.fulfillment.delivery)) {
          deliveryAddress.scrollIntoView({block: 'start'});
        } else if (errors['name']) {
          consumerName.scrollIntoView({block: 'start'});
        } else if (errors['email']) {
          const consumerEmail = document.getElementById('consumerEmail');
          consumerEmail.scrollIntoView({block: 'start'});
        } else if (errors['phone']) {
          const consumerPhone = document.getElementById('consumerPhone');
          consumerPhone.scrollIntoView({block: 'start'});
        } else if (errors['paymentType']) {
          const paymentType = document.getElementById('checkoutPaymentType');
          paymentType.scrollIntoView({block: 'start'});
        } else {
          consumerName.scrollIntoView({block: 'start'});
        }
      } else if (basket.messages && basket.messages) {
        deliveryAddress.scrollIntoView({block: 'start'});
      }
    }
  }

  closeErrorModal(){
    this.setState({invalidFormClick: 1});
  }

  render() {
    const {
      asyncValidating,
      basket,
      closeModal,
      dataInitializedFromStorage,
      date,
      error,
      checkoutForm,
      futureTimes,
      handleSubmit,
      invalid,
      isValidating,
      modalType,
      onDateChange,
      onTimeChange,
      openAllergyModal,
      openVoucherModal,
      paymentTypeValue,
      restaurant,
      serviceTypeValue,
      setPayment,
      setServiceType,
      setServiceTypeCollection,
      submitting,
      submitVoucher,
      voucherChange,
      voucherMessages,
      voucherValue,
      redirecting,
      isTemplateLight,
      orderFailed,
      handleErrorReportForm,
      tableId,
      clearTableId,
      navUrls
    } = this.props;
    const {invalidForm} = this.state;
    const {messages, price, items, fulfillment} = basket;
    const isDelivery = fulfillment && fulfillment.delivery;
    // show cash payment for e2e test: daily test order on jenkins (https://jenkins.foodit.com/job/Selenium-Tests-TestOrder)
    const OVERRIDE_CASH_PAYMENT =
      getValueFromLocalStorage(FOODIT_LOCALSTORAGE.OVERRIDE_CASH_PAYMENT) === 'true' ||
      getValueFromLocalStorage(FOODIT_LOCALSTORAGE.OVERRIDE_CASH_PAYMENT) === true;

    const openForCollection = restaurant.modes.futureOrders || checkOpeningTime(restaurant.openingTimes.collection);
    const openForDelivery = restaurant.modes.futureOrders || checkOpeningTime(restaurant.openingTimes.delivery);

    const renderServiceType = ServiceType({
      isValidating,
      openForCollection,
      openForDelivery,
      restaurantModes: restaurant.modes,
      setServiceType,
      tableId
    });

    const renderNotDineIn = tableId && (
      <NotDineIn onClick={clearTableId}>Not dining in? <NotDineInLink>Tap here</NotDineInLink></NotDineIn>
    );

    const showCheckoutDeliveryFee =
      SERVICE_TYPE.DELIVERY &&
      price.delivery > 0 &&
      messages.length === 0 &&
      restaurant.deliverySettings &&
      restaurant.deliverySettings.minimumAmount <= price.items;

    const showDeliveryMinimumAmountError =
      SERVICE_TYPE.DELIVERY && restaurant.deliverySettings && restaurant.deliverySettings.minimumAmount > price.items;

    const renderDeliveryAddress =
      serviceTypeValue === SERVICE_TYPE.DELIVERY &&
      DeliveryAddress({
        basketMessages: messages,
        basketPrice: price,
        dataInitializedFromStorage,
        showCheckoutDeliveryFee,
        showDeliveryMinimumAmountError,
        deliverySettings: restaurant.deliverySettings,
        setServiceTypeCollection
      });

    const renderConsumerData = ConsumerData({dataInitializedFromStorage});

    const renderFutureOrder =
      restaurant.modes.futureOrders &&
      FutureOrder({
        date,
        futureTimes,
        isDatepickerDayBlocked: this.isDatepickerDayBlocked,
        onDateChange,
        onTimeChange,
        openingTimes: restaurant.openingTimes,
        serviceTypeValue
      });

    const renderComments = Comments(tableId);

    const renderSubscribe =
      basket &&
      (
        !basket.consumer ||
        !(basket.consumer && basket.consumer && basket.consumer.emailSubscription && basket.consumer && basket.consumer.phoneSubscription)
      ) &&
      <Subscribe consumer={basket.consumer} />;

    const renderExtraInformation = ExtraInformation({
      closeModal,
      modalType,
      openAllergyModal,
      openVoucherModal,
      submitVoucher,
      voucherChange,
      voucherMessages,
      vouchersEnabled: restaurant.modes.voucher || restaurant.modes.vouchers,
      voucherValue,
      basket
    });
    const basketContainsErrorMessage = checkMessgeContainsError(messages);
    const disableSubmitButton = submitting || asyncValidating !== false || items.length === 0 ;
    const greySubmitButton = invalid || basketContainsErrorMessage || (messages && messages.length > 0);
    const isCashActive = (restaurant.payment.types.indexOf(PAYMENT_TYPES.CASH) > -1 || OVERRIDE_CASH_PAYMENT) && !tableId;
    const isCreditCardActive = restaurant.payment.types.indexOf(PAYMENT_TYPES.CREDIT_CARD) > -1;
    const isPaypalActive = restaurant.payment.types.indexOf(PAYMENT_TYPES.PAYPAL) > -1;
    const placeOrderButtonText = getPlaceOrderButtonText(paymentTypeValue, serviceTypeValue);
    const showInvalidFormData = (invalid || (messages && messages.length > 0)) && invalidForm;
    const showPaymentTypeRequiredError = !this.props.paymentTypeValue && invalidForm;
    const showNoFee = price && price.orderFee === 0;

    const renderPayments = Payments({
      disableSubmitButton,
      formError: error,
      greySubmitButton,
      handleFormErrors: this.handleFormErrors,
      isCashActive,
      isCreditCardActive,
      isPaypalActive,
      isValidating,
      paymentTypeValue,
      serviceTypeValue,
      setPayment,
      placeOrderButtonText,
      showInvalidFormData,
      showPaymentTypeRequiredError,
      showNoFee,
      checkoutForm,
      basketContainsErrorMessage,
      basketMessages: messages,
      isDelivery,
      submitting,
      redirecting,
      isTemplateLight,
      orderFailed,
      handleErrorReportForm,
      restaurantCode: restaurant.code,
      navUrls
    });

    const showErrorModal = this.state.invalidFormClick > 1 && (
      <CheckoutErrorModal
        errors={checkoutForm.syncErrors}
        isDelivery={isDelivery}
        handleCloseModal={this.closeErrorModal}
      />
    );

    return (
      <Form handleSubmit={handleSubmit}>
        {renderServiceType}
        {renderNotDineIn}
        {renderDeliveryAddress}
        {renderConsumerData}
        {renderFutureOrder}
        {renderComments}
        {renderSubscribe}
        {renderExtraInformation}
        {renderPayments}
        {showErrorModal}
      </Form>
    );
  }
}

CheckoutForm.propTypes = {
  asyncValidate: PropTypes.func.isRequired,
  asyncValidating: PropTypes.any.isRequired, //eslint-disable-line react/forbid-prop-types
  basket: PropTypes.object.isRequired,
  closeModal: PropTypes.func.isRequired,
  dataInitializedFromStorage: PropTypes.bool.isRequired,
  date: PropTypes.object.isRequired,
  error: PropTypes.string,
  futureTimes: PropTypes.array.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  invalid: PropTypes.bool.isRequired,
  isValidating: PropTypes.bool.isRequired,
  modalType: PropTypes.string,
  onDateChange: PropTypes.func.isRequired,
  onTimeChange: PropTypes.func.isRequired,
  openAllergyModal: PropTypes.func.isRequired,
  openVoucherModal: PropTypes.func.isRequired,
  paymentTypeValue: PropTypes.string,
  pristine: PropTypes.bool.isRequired,
  restaurant: PropTypes.object.isRequired,
  serviceTypeValue: PropTypes.string,
  setPayment: PropTypes.func.isRequired,
  setServiceType: PropTypes.func.isRequired,
  setServiceTypeCollection: PropTypes.func.isRequired,
  submitting: PropTypes.bool.isRequired,
  submitVoucher: PropTypes.func.isRequired,
  voucherChange: PropTypes.func.isRequired,
  voucherMessages: PropTypes.array,
  checkoutForm: PropTypes.object,
  voucherValue: PropTypes.string,
  redirecting: PropTypes.bool.isRequired,
  isTemplateLight: PropTypes.bool,
  orderFailed: PropTypes.bool.isRequired,
  handleErrorReportForm: PropTypes.func.isRequired,
  tableId: PropTypes.string,
  clearTableId: PropTypes.func,
  navUrls: PropTypes.object
};

const form = {
  form: 'checkoutForm',
  destroyOnUnmount: false,
  enableReinitialize: true,
  asyncBlurFields: ['addressLine1', 'addressLine2', 'postcode', 'city', 'name', 'email', 'phone'],
  shouldAsyncValidate: () => true
};

const selector = formValueSelector('checkoutForm');

function mapStateToProps(state, props) {
  const serviceTypeValue = selector(state, 'serviceType');
  const paymentTypeValue = selector(state, 'paymentType');

  const checkoutData = state.checkoutData;
  const dataInitializedFromStorage = Object.keys(checkoutData).length > 0;
  const nameInitialValue = checkoutData && checkoutData.name ? checkoutData.name : null;
  const emailInitialValue = checkoutData && checkoutData.email ? checkoutData.email : null;
  const phoneInitialValue = checkoutData && checkoutData.phone ? checkoutData.phone : null;

  const addressLine1InitialValue = checkoutData && checkoutData.addressLine1 ? checkoutData.addressLine1 : null;
  const addressLine2InitialValue = checkoutData && checkoutData.addressLine2 ? checkoutData.addressLine2 : null;
  const cityInitialValue = checkoutData && checkoutData.city ? checkoutData.city : null;
  const postcodeInitialValue = checkoutData && checkoutData.postcode ? checkoutData.postcode : null;
  const paymentTypeInitialValue = checkoutData && checkoutData.paymentType ? checkoutData.paymentType.toString() : null;

  const {fulfillment} = state.basket;
  const openForDelivery =
    props.restaurant.modes.futureOrders || checkOpeningTime(props.restaurant.openingTimes.delivery);
  const openForCollection =
    props.restaurant.modes.futureOrders || checkOpeningTime(props.restaurant.openingTimes.collection);

  const serviceTypeInitialValue = getServiceTypeInitialValue(openForDelivery, openForCollection, fulfillment);
  return {
    serviceTypeValue,
    paymentTypeValue,
    dataInitializedFromStorage,
    initialValues: {
      addressLine1: addressLine1InitialValue,
      addressLine2: addressLine2InitialValue,
      city: cityInitialValue,
      email: emailInitialValue,
      name: nameInitialValue,
      paymentType: paymentTypeInitialValue,
      phone: phoneInitialValue,
      postcode: postcodeInitialValue,
      serviceType: serviceTypeInitialValue,
      comments: props.tableId ? `${DINE_COMMENT} ${props.tableId} ` : ''
    }
  };
}

export default connect(mapStateToProps)(reduxForm(form)(CheckoutForm));



// WEBPACK FOOTER //
// ./containers/CheckoutPage/CheckoutForm.js